<main id="main-content" class="ds-product-page">
  <p class="eyebrow">{{ 'admin.eyebrow' | t }}</p>
  <h1>{{ 'admin.title' | t }}</h1>
  <p class="lede">{{ 'admin.lede' | t }}</p>
  @if (error()) {
    <p class="error" role="alert">{{ error() }}</p>
  }
  @if (!user()) {
    <form (ngSubmit)="login()">
      <h2>{{ 'admin.login' | t }}</h2>
      <label for="admin-email">{{ 'common.email' | t }}</label
      ><input dsInput id="admin-email" type="email" [formControl]="email" /><button
        dsButton
        type="submit"
        [disabled]="busy() || email.invalid"
      >
        {{ 'admin.open' | t }}
      </button>
    </form>
  } @else {
    @if (dashboard(); as data) {
      <section dsCard class="card">
        <h2>{{ 'admin.overview' | t }}</h2>
        <div class="metrics">
          <p>
            <strong>{{ data.users }}</strong
            ><span>{{ 'admin.users' | t }}</span>
          </p>
          <p>
            <strong>{{ data.publishedItems }}/{{ data.items }}</strong
            ><span>{{ 'admin.publishedItems' | t }}</span>
          </p>
          <p>
            <strong>{{ data.payments }}</strong
            ><span>{{ 'admin.payments' | t }}</span>
          </p>
          <p>
            <strong>{{ data.organizationInvoices }}</strong
            ><span>{{ 'admin.invoices' | t }}</span>
          </p>
          <p>
            <strong>{{ data.pendingPrivacyRequests }}</strong
            ><span>{{ 'admin.privacyQueue' | t }}</span>
          </p>
          <p>
            <strong>{{ data.failedJobs }}</strong
            ><span>{{ 'admin.failedJobs' | t }}</span>
          </p>
        </div>
      </section>
    }
    <section dsCard class="card">
      <div class="heading">
        <div>
          <h2>{{ 'admin.review' | t }}</h2>
          <p>{{ 'admin.reviewText' | t }}</p>
        </div>
        <button dsButton type="button" (click)="importItem()" [disabled]="busy()">
          {{ 'admin.import' | t }}
        </button>
      </div>
      <ul>
        @for (item of items(); track item.id) {
          <li>
            <div>
              <strong>{{ item.familyCode }} · {{ item.domain }}</strong
              ><span>{{ item.prompt }} · {{ item.calibrationStatus }}</span>
            </div>
            @if (!item.published) {
              <button dsButton type="button" (click)="publish(item)" [disabled]="busy()">
                {{ 'admin.publish' | t }}
              </button>
            } @else {
              <span class="status">{{ 'common.published' | t }}</span>
            }
          </li>
        }
      </ul>
    </section>
    <section dsCard class="card">
      <h2>{{ 'admin.privacy' | t }}</h2>
      <ul>
        @for (request of privacyRequests(); track request.id) {
          <li>
            <div>
              <strong>{{ request.type }}</strong
              ><span>{{ request.status }} · {{ request.submittedAtUtc }}</span>
            </div>
            @if (request.status === 'Submitted') {
              <button dsButton type="button" (click)="process(request)" [disabled]="busy()">
                {{ 'admin.process' | t }}
              </button>
            }
          </li>
        }
      </ul>
    </section>
    <section dsCard class="card">
      <div class="heading">
        <div>
          <h2>{{ 'admin.jobs' | t }}</h2>
          <p>{{ 'admin.jobsText' | t }}</p>
        </div>
        <button dsButton type="button" (click)="cleanup()" [disabled]="busy()">
          {{ 'admin.cleanup' | t }}
        </button>
      </div>
      <ul>
        @for (job of jobs(); track job.id) {
          <li>
            <div>
              <strong>{{ job.jobType }}</strong
              ><span>{{ job.status }} · {{ job.attempts }} {{ 'common.attempts' | t }}</span>
            </div>
          </li>
        }
      </ul>
    </section>
    <section dsCard class="card">
      <h2>{{ 'admin.audit' | t }}</h2>
      <ul>
        @for (entry of audit(); track entry.id) {
          <li>
            <div>
              <strong>{{ entry.action }}</strong
              ><span>{{ entry.targetType }} · {{ entry.occurredAtUtc }}</span>
            </div>
          </li>
        }
      </ul>
    </section>
  }
</main>
